import React, { FC, memo, ReactNode } from "react";

/**
 * Layout Props Interface
 * @interface LayoutProps
 */
interface LayoutProps {}

/**
 * Component Props Interface
 * @interface ComponentProps
 */
interface ComponentProps {}

/**
 * Public Route Props Interface
 * @interface PublicRouteProps
 */
interface PublicRouteProps {
  layout: FC<LayoutProps>;
  component: FC<ComponentProps>;
  exact?: boolean;
  children?: ReactNode;
  extraProps?: Record<string, any>;
}

const PublicRoute: FC<PublicRouteProps> = ({
  component: Component,
  layout: Layout,
  children,
  extraProps,
}) => {
  return (
    <Layout>
      <Component {...extraProps}>{children}</Component>
    </Layout>
  );
};

export default memo(PublicRoute);
